module.exports = {
	actionNewCustom18: 'rgb(77, 202, 118)',
	actionNewCustom29: 'rgb(189, 210, 95)',
	actionEditGroups: 'rgb(52, 190, 205)',
	actionNewCustom9: 'rgb(107, 158, 226)',
	actionLogACall: 'rgb(72, 195, 204)',
	actionNewCustom19: 'rgb(58, 190, 177)',
	actionFilter: 'rgb(253, 144, 181)',
	actionUserActivation: 'rgb(84, 105, 141)',
	actionOpportunityCompetitor: 'rgb(252, 185, 91)',
	actionCanvas: 'rgb(129, 153, 175)',
	actionChangeRecordType: 'rgb(84, 105, 141)',
	actionNewNotebook: 'rgb(230, 212, 120)',
	actionDocusign: 'rgb(80, 128, 219)',
	actionShareLink: 'rgb(122, 154, 230)',
	actionAddFile: 'rgb(126, 139, 228)',
	actionEditRelationship: 'rgb(29, 204, 191)',
	// Use ACTION_NEW_NOTEBOOK instead.
	actionNotebook: 'rgb(230, 212, 120)',
	actionNewLead: 'rgb(248, 137, 98)',
	actionNewCustomObject: 'rgb(167, 212, 77)',
	actionNewAccount: 'rgb(127, 141, 225)',
	actionQuestionPostAction: 'rgb(50, 175, 92)',
	actionShareFile: 'rgb(186, 172, 147)',
	actionDefaultCustomObject: 'rgb(129, 153, 175)',
	actionOpportunityTeamMember: 'rgb(252, 185, 91)',
	actionAddPhotoVideo: 'rgb(0, 205, 192)',
	actionSort: 'rgb(250, 185, 165)',
	actionCall: 'rgb(31, 202, 160)',
	actionConcur: 'rgb(76, 195, 199)',
	actionReject: 'rgb(0, 198, 183)',
	actionSharePoll: 'rgb(105, 155, 225)',
	actionFollowing: 'rgb(125, 207, 100)',
	actionDefer: 'rgb(239, 126, 173)',
	actionOpportunityLineItem: 'rgb(252, 185, 91)',
	actionSocialPost: 'rgb(234, 116, 162)',
	actionSharePost: 'rgb(101, 202, 228)',
	actionViewRelationship: 'rgb(60, 151, 221)',
	actionUpload: 'rgb(84, 105, 141)',
	actionRemoveRelationship: 'rgb(239, 110, 100)',
	actionFreezeUser: 'rgb(84, 105, 141)',
	actionNewPersonAccount: 'rgb(127, 141, 225)',
	actionApex: 'rgb(105, 110, 113)',
	actionNewOpportunity: 'rgb(252, 185, 91)',
	actionFallback: 'rgb(152, 149, 238)',
	actionDialIn: 'rgb(139, 154, 227)',
	actionApproval: 'rgb(0, 198, 183)',
	actionChangeOwner: 'rgb(84, 105, 141)',
	actionNewTask: 'rgb(75, 192, 118)',
	actionPriority: 'rgb(251, 180, 57)',
	actionRemove: 'rgb(84, 105, 141)',
	actionWebLink: 'rgb(86, 170, 223)',
	actionLeaveGroup: 'rgb(243, 158, 88)',
	actionManagePermSets: 'rgb(84, 105, 141)',
	actionClose: 'rgb(239, 110, 100)',
	actionGoogleNews: 'rgb(245, 103, 91)',
	actionAnnouncement: 'rgb(254, 143, 96)',
	actionBack: 'rgb(13, 194, 217)',
	actionNewCustom90: 'rgb(34, 164, 138)',
	actionDownload: 'rgb(84, 105, 141)',
	actionNewCustom80: 'rgb(101, 154, 213)',
	actionNewCustom91: 'rgb(191, 123, 102)',
	actionSearch: 'rgb(72, 173, 235)',
	actionNewEvent: 'rgb(235, 112, 146)',
	actionNewCustom70: 'rgb(231, 105, 180)',
	actionNewCustom81: 'rgb(218, 98, 127)',
	actionNewCustom92: 'rgb(81, 126, 130)',
	actionRefresh: 'rgb(84, 105, 141)',
	actionShareThanks: 'rgb(233, 105, 110)',
	actionUpdate: 'rgb(129, 180, 214)',
	actionEmail: 'rgb(149, 174, 197)',
	actionJoinGroup: 'rgb(119, 158, 242)',
	actionNewCustom60: 'rgb(191, 90, 136)',
	actionNewCustom71: 'rgb(227, 110, 227)',
	actionNewCustom82: 'rgb(209, 91, 151)',
	actionNewCustom93: 'rgb(144, 77, 76)',
	actionEdit: 'rgb(29, 204, 191)',
	actionQuote: 'rgb(136, 198, 81)',
	actionDropbox: 'rgb(82, 174, 249)',
	actionDescription: 'rgb(125, 195, 125)',
	actionMap: 'rgb(118, 198, 238)',
	actionUser: 'rgb(101, 202, 228)',
	actionResetPassword: 'rgb(84, 105, 141)',
	actionNewCustom50: 'rgb(73, 188, 211)',
	actionNewCustom61: 'rgb(245, 115, 118)',
	actionNewCustom72: 'rgb(141, 155, 251)',
	actionNewCustom83: 'rgb(231, 128, 111)',
	actionNewCustom94: 'rgb(67, 156, 186)',
	actionClone: 'rgb(108, 161, 233)',
	actionScript: 'rgb(0, 112, 210)',
	actionDelete: 'rgb(230, 113, 124)',
	actionNewCustom40: 'rgb(131, 199, 94)',
	actionNewCustom51: 'rgb(216, 199, 96)',
	actionNewCustom62: 'rgb(107, 146, 220)',
	actionNewCustom73: 'rgb(103, 158, 240)',
	actionNewCustom84: 'rgb(246, 112, 123)',
	actionNewCustom95: 'rgb(139, 207, 106)',
	actionShare: 'rgb(84, 105, 141)',
	actionNewCustom30: 'rgb(245, 159, 113)',
	actionNewCustom41: 'rgb(67, 181, 181)',
	actionNewCustom52: 'rgb(238, 142, 111)',
	actionNewCustom63: 'rgb(124, 207, 96)',
	actionNewCustom74: 'rgb(65, 200, 160)',
	actionNewCustom85: 'rgb(242, 104, 145)',
	actionNewCustom96: 'rgb(109, 157, 227)',
	actionLogEvent: 'rgb(108, 161, 233)',
	actionNewGroup: 'rgb(131, 182, 255)',
	actionNewCustom20: 'rgb(72, 199, 200)',
	actionNewCustom31: 'rgb(235, 104, 127)',
	actionNewCustom42: 'rgb(207, 208, 91)',
	actionInfo: 'rgb(84, 105, 141)',
	actionNewCustom53: 'rgb(243, 110, 131)',
	actionNewCustom64: 'rgb(97, 143, 216)',
	actionNewCustom75: 'rgb(205, 159, 101)',
	actionNewCustom86: 'rgb(226, 96, 171)',
	actionFlow: 'rgb(0, 121, 188)',
	actionNewCustom97: 'rgb(221, 96, 133)',
	actionSubmitForApproval: 'rgb(80, 204, 122)',
	actionNew: 'rgb(51, 188, 231)',
	actionNewCampaign: 'rgb(244, 151, 86)',
	actionNewCustom10: 'rgb(100, 136, 227)',
	actionNewCustom21: 'rgb(138, 122, 237)',
	actionNewCustom32: 'rgb(56, 195, 147)',
	actionNewCustom43: 'rgb(127, 147, 249)',
	actionNewCustom54: 'rgb(234, 112, 177)',
	actionNewCustom65: 'rgb(242, 121, 171)',
	actionNewCustom76: 'rgb(219, 109, 122)',
	actionNewCustom87: 'rgb(216, 118, 229)',
	actionNewCustom98: 'rgb(225, 190, 92)',
	actionNewCase: 'rgb(242, 207, 91)',
	actionNewCustom100: 'rgb(225, 93, 118)',
	actionNewCustom1: 'rgb(255, 123, 132)',
	actionNewContact: 'rgb(160, 148, 237)',
	actionOffice365: 'rgb(255, 128, 65)',
	actionNewCustom11: 'rgb(135, 132, 234)',
	actionNewCustom22: 'rgb(139, 133, 249)',
	actionNewCustom33: 'rgb(151, 207, 93)',
	actionNewCustom44: 'rgb(200, 202, 88)',
	actionNewCustom55: 'rgb(214, 110, 224)',
	actionNewCustom66: 'rgb(216, 190, 95)',
	actionNewCustom77: 'rgb(181, 93, 91)',
	actionNewCustom88: 'rgb(153, 111, 230)',
	actionNewCustom99: 'rgb(240, 133, 110)',
	actionAddContact: 'rgb(160, 148, 237)',
	actionEvernote: 'rgb(134, 200, 111)',
	actionNewCustom2: 'rgb(207, 208, 92)',
	actionLeadConvert: 'rgb(248, 137, 98)',
	actionNewCustom12: 'rgb(220, 113, 209)',
	actionNewCustom23: 'rgb(176, 112, 230)',
	actionNewCustom34: 'rgb(213, 138, 106)',
	actionNewCustom45: 'rgb(217, 88, 121)',
	actionNewCustom56: 'rgb(113, 141, 235)',
	actionNewCustom67: 'rgb(248, 125, 118)',
	actionRecall: 'rgb(74, 105, 141)',
	actionNewCustom78: 'rgb(90, 149, 221)',
	actionNewCustom89: 'rgb(62, 153, 190)',
	actionFollow: 'rgb(49, 185, 248)',
	actionRecord: 'rgb(125, 195, 125)',
	actionNewCustom3: 'rgb(236, 180, 108)',
	actionNewNote: 'rgb(230, 212, 120)',
	actionNewCustom13: 'rgb(223, 97, 132)',
	actionNewCustom24: 'rgb(229, 103, 152)',
	actionNewCustom35: 'rgb(233, 99, 126)',
	actionNewCustom46: 'rgb(103, 165, 231)',
	actionNewCustom57: 'rgb(90, 156, 221)',
	actionNewCustom68: 'rgb(242, 105, 121)',
	actionNewCustom79: 'rgb(142, 211, 99)',
	actionNewChildCase: 'rgb(250, 151, 92)',
	actionNewCustom4: 'rgb(225, 217, 81)',
	actionNewCustom14: 'rgb(60, 194, 179)',
	actionNewCustom25: 'rgb(228, 111, 190)',
	actionNewCustom36: 'rgb(212, 114, 212)',
	actionNewCustom47: 'rgb(95, 204, 100)',
	actionNewCustom58: 'rgb(52, 181, 157)',
	actionNewCustom69: 'rgb(237, 99, 135)',
	actionNewCustom5: 'rgb(159, 219, 102)',
	actionGoal: 'rgb(86, 170, 223)',
	actionNewCustom15: 'rgb(247, 126, 117)',
	actionNewCustom26: 'rgb(118, 152, 240)',
	actionNewCustom37: 'rgb(140, 137, 242)',
	actionNewCustom48: 'rgb(239, 105, 127)',
	actionNewCustom59: 'rgb(227, 208, 103)',
	actionNewCustom6: 'rgb(84, 196, 115)',
	actionLogThisEvent: 'rgb(235, 112, 146)',
	actionNewCustom16: 'rgb(233, 175, 103)',
	actionNewCustom27: 'rgb(90, 176, 210)',
	actionNewCustom38: 'rgb(83, 182, 215)',
	actionNewCustom49: 'rgb(226, 92, 128)',
	actionNewCustom7: 'rgb(106, 137, 229)',
	actionMore: 'rgb(98, 183, 237)',
	actionAddRelationship: 'rgb(98, 183, 237)',
	actionNewCustom17: 'rgb(172, 211, 96)',
	actionNewCustom28: 'rgb(137, 192, 89)',
	actionNewCustom39: 'rgb(79, 190, 117)',
	actionPasswordUnlock: 'rgb(84, 105, 141)',
	actionCheck: 'rgb(84, 105, 141)',
	actionUpdateStatus: 'rgb(30, 199, 190)',
	actionPreview: 'rgb(127, 141, 225)',
	actionNewCustom8: 'rgb(80, 206, 185)',
};
